package com.rabbitsign.common

import kotlinx.serialization.Serializable

typealias SignerFields = MutableList<FieldSpec>

@Serializable
data class SignerFieldsWithDate(val date: String, val fields: SignerFields)
